export default __webpack_public_path__ + "static/media/smiley4-filled.c6ef72af.svg";